// Tiny event emitter used by the web call core.
// Kept local so FRONT and ADMIN share the same call implementation
// without introducing another runtime dependency.
export function createEmitter() {
    const listeners = new Map();

    const on = (event, handler) => {
        if (!event || typeof handler !== 'function') return;
        const set = listeners.get(event) || new Set();
        set.add(handler);
        listeners.set(event, set);
    };

    const off = (event, handler) => {
        const set = listeners.get(event);
        if (!set) return;
        set.delete(handler);
        if (!set.size) listeners.delete(event);
    };

    const emit = (event, payload) => {
        const set = listeners.get(event);
        if (!set) return;
        [...set].forEach((handler) => {
            try { handler(payload); } catch (error) {
                console.error('[calls][emitter]', event, error);
            }
        });
    };

    return { on, off, emit };
}
